/**
 * Premium Header & Mega Menu Scripts
 */

document.addEventListener('DOMContentLoaded', initHeader);

// Run when the section reloads in the Shopify Theme Editor
document.addEventListener('shopify:section:load', initHeader);

function initHeader() {
  initStickyHeader();
  initMobileDrawer();
  initMegaMenuA11y();
}

/**
 * Sticky Header
 */
function initStickyHeader() {
  const header = document.querySelector('.premium-header');
  if (!header || header.dataset.sticky !== 'true') return;

  const SCROLL_THRESHOLD = 50;
  const isTransparent = header.classList.contains('premium-header--transparent');

  function onScroll() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('premium-header--sticky');
      // Remove transparent class so the white bg from --sticky takes effect
      if (isTransparent) {
        header.classList.remove('premium-header--transparent');
      }
    } else {
      header.classList.remove('premium-header--sticky');
      // Restore transparent class when scrolled back to top
      if (isTransparent) {
        header.classList.add('premium-header--transparent');
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load
}

/**
 * Mobile Drawer Logic
 */
function initMobileDrawer() {
  const toggleBtn = document.querySelector('.premium-header__mobile-toggle');
  const closeBtn = document.querySelector('.mobile-drawer__close');
  const drawer = document.getElementById('mobileDrawer');
  
  if (!toggleBtn || !drawer) return;

  const openDrawer = () => {
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    // Simple focus trap
    setTimeout(() => {
      const firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }, 100);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    toggleBtn.focus();
  };

  toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Accordion Logic for mobile menu
  const accordions = drawer.querySelectorAll('.mobile-nav__toggle');
  accordions.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = btn.closest('.mobile-nav__item');
      const isExpanded = parent.classList.contains('is-expanded');
      
      // Close all siblings if desired (optional)
      // parent.parentNode.querySelectorAll('.mobile-nav__item').forEach(p => p.classList.remove('is-expanded'));
      
      if (isExpanded) {
        parent.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        parent.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/**
 * Mega Menu Accessibility & Hover Intents
 */
function initMegaMenuA11y() {
  const navItems = document.querySelectorAll('.nav-item');
  
  navItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-menu, .simple-dropdown');
    if (!megaMenu) return;

    const link = item.querySelector('.nav-link');
    
    // Close on escape
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        link.focus();
        item.blur(); // Remove focus-within
      }
    });

    // Sub-menu hover handling (Left/Right panels)
    if (megaMenu.classList.contains('mega-menu')) {
      const categoryLinks = megaMenu.querySelectorAll('.mega-menu__category-link');
      const panels = megaMenu.querySelectorAll('.mega-menu__panel');

      categoryLinks.forEach((catLink) => {
        catLink.addEventListener('mouseenter', () => {
          const targetId = catLink.dataset.target;
          if (!targetId) return;

          // Remove active class from all
          categoryLinks.forEach(c => c.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));

          // Add to current
          catLink.classList.add('is-active');
          const targetPanel = megaMenu.querySelector(`#${targetId}`);
          if (targetPanel) {
            targetPanel.classList.add('is-active');
          }
        });
        
        // Keyboard support for activating right panel
        catLink.addEventListener('focus', () => {
          const targetId = catLink.dataset.target;
          if (!targetId) return;

          categoryLinks.forEach(c => c.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));

          catLink.classList.add('is-active');
          const targetPanel = megaMenu.querySelector(`#${targetId}`);
          if (targetPanel) {
            targetPanel.classList.add('is-active');
          }
        });
      });
    }
  });
}
